import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

export default function ContactPage() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50 font-sans">
      {/* ส่วนหัวเว็บไซต์ */}
      <SiteHeader />

      {/* ส่วนเนื้อหาหลัก */}
      <main className="flex-grow container mx-auto px-4 py-12 md:py-16 max-w-6xl">
        {/* หัวข้อหน้า */}
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">ติดต่อเรา</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่ (Culture Reader @NL.CNX)
          </p>
        </div>

        {/* การ์ดเนื้อหา (แบ่ง 2 คอลัมน์) */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col lg:flex-row">
          
          {/* คอลัมน์ซ้าย: ข้อมูลการติดต่อ */}
          <div className="w-full lg:w-5/12 p-8 md:p-10 bg-[#fbf9f6]"> {/* โทนสีพื้นหลังอุ่นๆ ให้ฟีลห้องสมุด */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">ข้อมูลการติดต่อ</h2>
            
            <div className="space-y-6">
              {/* ที่อยู่ */}
              <div className="flex items-start space-x-4">
                <svg className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                <div>
                  <h3 className="font-medium text-gray-900 mb-1">ที่อยู่</h3>
                  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                    20/1 ถนน บุญเรืองฤทธิ์<br />
                    ตำบล หายยา อำเภอเมืองเชียงใหม่<br />
                    เชียงใหม่ 50100
                  </p>
                </div>
              </div>

              {/* เบอร์โทรศัพท์ */}
              <div className="flex items-start space-x-4">
                <svg className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                <div>
                  <h3 className="font-medium text-gray-900 mb-1">เบอร์โทรศัพท์</h3>
                  <p className="text-gray-600 text-sm md:text-base">053-278-322</p>
                </div>
              </div>
            </div>

            <hr className="my-8 border-gray-200" />

            {/* ช่องทางออนไลน์ */}
            <h3 className="font-medium text-gray-900 mb-4">ติดตามช่องทางออนไลน์</h3>
            <div className="space-y-4">
              <a href="http://www.finearts.go.th/chiangmailibrary/" target="_blank" rel="noreferrer" className="flex items-center space-x-3 text-gray-600 hover:text-[#8B4513] transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path></svg>
                <span className="text-sm md:text-base text-ellipsis overflow-hidden">เว็บไซต์กรมศิลปากร</span>
              </a>
              <a href="https://www.facebook.com/nl.chiangmai" target="_blank" rel="noreferrer" className="flex items-center space-x-3 text-gray-600 hover:text-blue-600 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.597 0 0 .597 0 1.325v21.351C0 23.403.597 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.597 1.323-1.324V1.325C24 .597 23.403 0 22.675 0z"/></svg>
                <span className="text-sm md:text-base">Facebook: nl.chiangmai</span>
              </a>
              <a href="https://www.tiktok.com/@nl.cnx" target="_blank" rel="noreferrer" className="flex items-center space-x-3 text-gray-600 hover:text-black transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.525.02c1.31-.02 2.61-.01 3.91.04.18 1.48.96 2.84 2.15 3.73 1.15.86 2.59 1.25 4.02 1.14v4.13c-1.36-.07-2.69-.47-3.86-1.16-.62-.36-1.18-.81-1.65-1.34v8.28c-.02 2.62-1.37 5.09-3.58 6.54-2.26 1.48-5.18 1.71-7.65.6-2.5-1.11-4.22-3.41-4.57-6.13-.37-2.77.85-5.54 3.08-7.14 2.16-1.54 5-1.96 7.55-.98v4.36c-1.25-.66-2.74-.75-4.06-.24-1.35.5-2.39 1.6-2.73 2.97-.33 1.36.03 2.83.95 3.89.92 1.05 2.34 1.58 3.76 1.4 1.43-.17 2.66-.99 3.27-2.28.52-1.1.75-2.33.7-3.56V.02z"/></svg>
                <span className="text-sm md:text-base">TikTok: @nl.cnx</span>
              </a>
            </div>
          </div>

          {/* คอลัมน์ขวา: Google Maps */}
          <div className="w-full lg:w-7/12 min-h-[400px] lg:min-h-full">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3777.2321968547913!2d98.97511127600562!3d18.78780268235844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da3a8484a089d9%3A0xd3e76cbb9a08b9c3!2z4Lir4Lit4Liq4Lih4Li44LiU4LmB4Lir4LmI4LiH4LiK4Liy4LiV4Li04Lij4Lix4LiK4Lih4Lix4LiH4LiE4Lil4Liy4Lig4Li04LmA4Lip4LiBIOC5gOC4iuC4teC4ouC4h-C5g-C4q-C4oeC5iA!5e0!3m2!1sth!2sth!4v1771998384768!5m2!1sth!2sth" 
              className="w-full h-full"
              style={{ border: 0, minHeight: "400px" }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="แผนที่หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่"
            ></iframe>
          </div>

        </div>
      </main>

      {/* ส่วนท้ายเว็บไซต์ */}
      <Footer />
    </div>
  );
}